import Image from 'next/image';

import { AnalyticsEvents, captureAnalyticsEvent } from '@lib/analytics/events';
import type { AnalyticsAppStore } from '@lib/analytics/events';
import { HOMEPAGE_APP_STORE_LINKS } from '@lib/homepage/app-links';

// Both badge assets share a ~3.37:1 aspect ratio.
const BADGE_HEIGHT = 40;
const BADGE_WIDTH = 135;

type StoreBadge = {
  store: AnalyticsAppStore;
  imageSrc: string;
  alt: string;
};

const STORE_BADGES: StoreBadge[] = [
  {
    store: 'app_store',
    imageSrc: '/images/app-store-badge.png',
    alt: 'Download on the App Store'
  },
  {
    store: 'google_play',
    imageSrc: '/images/google-play-badge.svg',
    alt: 'Get it on Google Play'
  }
];

type StoreBadgesProps = {
  /** Which part of the page the badges sit in, for the click event. */
  placement: string;
  className?: string;
};

const StoreBadges = ({ placement, className = '' }: StoreBadgesProps) => (
  <ul className={`flex flex-wrap items-center gap-3 ${className}`}>
    {STORE_BADGES.map(({ store, imageSrc, alt }) => (
      <li key={store}>
        <a
          href={HOMEPAGE_APP_STORE_LINKS[store]}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
          data-cy={`store-badge-${store}`}
          onClick={() =>
            captureAnalyticsEvent(AnalyticsEvents.appBadgeClicked, {
              placement,
              store
            })
          }
        >
          <Image
            src={imageSrc}
            alt={alt}
            height={BADGE_HEIGHT}
            width={BADGE_WIDTH}
          />
        </a>
      </li>
    ))}
  </ul>
);

export default StoreBadges;
